/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CnyWalletBillEnumItem
 */
export interface CnyWalletBillEnumItem {
    /**
     * 编码
     * @type {number}
     * @memberof CnyWalletBillEnumItem
     */
    code?: number;
    /**
     * 名称（根据语言环境返回）
     * @type {string}
     * @memberof CnyWalletBillEnumItem
     */
    name?: string;
}

/**
 * Check if a given object implements the CnyWalletBillEnumItem interface.
 */
export function instanceOfCnyWalletBillEnumItem(value: object): value is CnyWalletBillEnumItem {
    return true;
}

export function CnyWalletBillEnumItemFromJSON(json: any): CnyWalletBillEnumItem {
    return CnyWalletBillEnumItemFromJSONTyped(json, false);
}

export function CnyWalletBillEnumItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): CnyWalletBillEnumItem {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function CnyWalletBillEnumItemToJSON(json: any): CnyWalletBillEnumItem {
    return CnyWalletBillEnumItemToJSONTyped(json, false);
}

export function CnyWalletBillEnumItemToJSONTyped(value?: CnyWalletBillEnumItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'name': value['name'],
    };
}

